<script lang="ts">
    import {deleteDocument, getDocument, getDocumentsForProject} from "$lib/calls/document";
    import FileDrop from "$lib/components/FileDrop.svelte";
    import {storeFiles} from "$lib/calls/files";
    import {currentProject} from "$lib/stores/projectWizard";
    import {Button, Modal, Spinner} from "flowbite-svelte";
    import {
        DownloadOutline,
        ExclamationCircleOutline,
        TrashBinSolid
    } from "flowbite-svelte-icons";
    import ModalHeader from "$lib/components/ui/ModalHeader.svelte";
    import convertPdfToImage from "$lib/utils/convertPdfToImage";
    import ModalFooter from "$lib/components/ui/ModalFooter.svelte";
    import {globalConfirm} from "$lib/stores/modal";
    import {onMount} from "svelte";


    export let project;
    export let uploadable = false;

    let loading = false;

    let documents = [];
    onMount(async () => {
        documents = await getDocumentsForProject(project)
    })

    const extract = async (accepted, rejected) => {
        currentProject.set(project);
        loading = true;
        if (rejected.length > 0) {
            alert('Datei nicht erlaubt');
        }
        documents = [...documents, ...await storeFiles(accepted)]
        loading = false
    }

    const handleButtonClick = async (document) => {
        //const res = await getDocument(document)
        if (document.name.endsWith('.pdf') || document.name.endsWith('.jpg') || document.name.endsWith('.jpeg') || document.name.endsWith('.png_')) {
            previewModalDocument = document
            if (!document.name.endsWith('.pdf')) {
                return
            }
            previews = [];

            try {
                await render();
            } catch (e) {
                console.log(e);
            }
        } else {
            window.open(document.location, '_blank')
        }
    };


    let previews: string[] = [];
    const render = async () => {
        try {
            const converted = await convertPdfToImage(previewModalDocument.location);
            converted.forEach((preview) => {
                previews = [...previews, preview]
            })
        } catch (e) {
            console.error(e)
        }
    }


    let deleteModal = false;
    let previewModalDocument = null;

    let documentToBeDeleted;

    function confirmDelete(document) {
        deleteModal = true
        documentToBeDeleted = document
    }

    function executeDeletion() {
        deleteModal = false;
        loading = true;
        deleteDocument(documentToBeDeleted).then(() => {
            documents = documents.filter(x => x.id !== documentToBeDeleted.id)
            documentToBeDeleted = null
            loading = false;
        })
    }


</script>
{#if loading}
    <div class="text-center my-5">
        <Spinner/>
    </div>
{:else}
    {#if documents.length > 0}
        <ul class="divide-y divide-gray-100 rounded-md border border-gray-200">
            {#each documents as document}
                <li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                    <div class="flex w-0 flex-1 items-center">
                        <svg class="h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor"
                             aria-hidden="true">
                            <path fill-rule="evenodd"
                                  d="M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z"
                                  clip-rule="evenodd"/>
                        </svg>
                        <div class="ml-4 flex min-w-0 flex-1 gap-2">
                            <span class="truncate font-medium">{document.name}</span>
                        </div>
                    </div>
                    <div class="ml-4 flex-shrink-0 flex gap-2 items-center">

                        <button class="font-medium text-primary-600 hover:text-primary-500 cursor-pointer"
                                on:click={() => handleButtonClick(document)}>
                            {#if document.name.endsWith('.pdf') || document.name.endsWith('.jpg') || document.name.endsWith('.jpeg') || document.name.endsWith('.png')}
                                Vorschau
                            {:else}
                                Download
                            {/if}
                        </button>
                        <button on:click={() => confirmDelete(document)}>
                            <TrashBinSolid class="h-4 text-red-600 cursor-pointer"/>
                        </button>
                    </div>
                </li>
            {/each}
        </ul>
    {/if}
    {#if uploadable}
        <FileDrop allowedSize="4MB" {extract}/>
    {/if}
{/if}
<Modal bind:open={deleteModal} size="xs" autoclose>
    <div class="text-center">
        <ExclamationCircleOutline class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"/>
        <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Soll die Datei {documentToBeDeleted.name}
            wirklich gelöscht werden?</h3>
        <Button color="red" class="mr-2" on:click={executeDeletion}>
            Ja, ich bin sicher
        </Button>
        <Button color="alternative">Nein, abbrechen</Button>
    </div>
</Modal>


<Modal open="{previewModalDocument !== null}" size="xs" autoclose>
    <svelte:fragment slot="header">
        <ModalHeader>{previewModalDocument.name}</ModalHeader>
    </svelte:fragment>
    {#if previews.length > 0}
        {#each previews as preview,i}
            <div class="text-center mb-3">Seite {i + 1}</div>
            <img src={preview} alt="Seite-{i+1}">
        {/each}
    {:else}
        <img src={previewModalDocument.location} alt="">
    {/if}
    <svelte:fragment slot="footer">
        <ModalFooter>
            <div slot="left"/>
            <div slot="right">
                <Button id="download" href={previewModalDocument.location}
                        target="_blank">
                    <DownloadOutline></DownloadOutline>
                    Download
                </Button>
            </div>
        </ModalFooter>
    </svelte:fragment>
</Modal>

